import React, {FC, PropsWithChildren} from 'react';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledActionDiv = styled.div`
  position: relative;
  grid-area: action;

  padding: 0 5px;
  color: ${(p) => p.theme.bannerText};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

export const BannerSecondaryText: FC<PropsWithChildren<unknown>> = ({children}) => (
  <StyledActionDiv>{children}</StyledActionDiv>
);
